import styled from 'styled-components';
import { primaryColor, secondaryColor } from '@app/styles';

type StatusProps = {
  variant?: 'primary' | 'secondary' | 'magento' | 'success';
  width?: string;
};

export const StatusBarContainer = styled.div`
  // height: 20px;
  min-width: 40px;
  border: 0 none;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  padding: 6px 10px;
  text-transform: captalize;
  ${({ variant }: StatusProps) => {
    if (variant === 'primary') {
      return `
                background-color:rgb(209 227 254);
                color: ${primaryColor};
               
                &:hover {
                    background-color: rgb(209 227 254);
                }
            `;
    } else if (variant === 'secondary') {
      return `
                background-color: rgb(254 208 209);
                color: ${secondaryColor};
               
                &:hover {
                    background-color: rgb(254 208 209);
                }
            `;
    } else if (variant === 'magento') {
      return `
                background-color: rgb(231 219 254);
                
                color: rgb(144 71 168);
                &:hover {
                    background-color: rgb(231 219 254);
                }
            `;
    } else if (variant === 'success') {
      return `
                background-color: rgb(188 221 212);
                color: rgb(36,144,116);
                &:hover {
                    background-color: rgb(188 221 212);
                }
            `;
    }
  }}
`;
